import { Logger } from "@vm/logger";

export const logger = new Logger({
  level: import.meta.env.VITE_LOG_LEVEL || "info",
});
